/**
 * @desc 校验centerId是否存在
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.CenterCountyMappingResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/centerCounty/selectByCenterIds`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
